import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "StudyResc",
    isNumber: true,
    isSum: true,
  },
];

const groupOrders = {
  AgeStudyGroup1: {
    "<65": 0,
    "65-69": 1,
    "70-74": 2,
    "75-79": 3,
    "80-84": 4,
    ">=85": 5,
  },
};

export const AgeToCheckItemAnalysis = {
  label: "年齡層",
  key: "AgeToCheckItemAnalysis",
  path: "ElderlyHealthCheckup/AgeToCheckItemAnalysis",
  api: "TCS_V_OldStudyList01V",
  render: (options) => (
    <Diagram.ElderlyHealthCheckup.AgeToCheckItemAnalysis {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupOrders,
  groupColumns: [
    {
      key: "AgeStudyGroup1",
      field: "AgeStudyGroup1",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
